import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';

export default class RowItemProcess extends React.Component {

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          {this.props.item && this.props.item.tenDonVi}
        </td>
        <td style={{width: '300px', wordBreak: 'break-all'}}>
          {this.props.item && this.props.item.loaiQuyTrinhInfo && this.props.item.loaiQuyTrinhInfo.ten}
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('PROCESS_XOA') &&
                <DeleteDialog
                  title={'Xoá danh mục'}
                  content={'Bạn chắc chắn muốn xoá danh mục này?'}
                  redux={this.props.parent}
                  deleteId={this.props.item.donViId}
                  buttonLoading={this.props.buttonLoading}
                />
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemProcess.jsx